import React, { useState, useEffect, useCallback } from "react";
// import user from "../../assets/user-profile.jpg";
import user from "../../assets/profile.jpg";
import TextInput from "../fields/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineFileUpload } from "react-icons/md";
import { Tooltip as ReactTooltip } from "react-tooltip";
import editPen from "../../assets/edit.png";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import {
  EditUserProfile,
  getEarning,
  getUserDetail,
  fetchWithdrawls,
  clearEditProfile,
} from "../../redux/Slice/authSlice";
import { toast } from "react-toastify";
import licence from "../../assets/licence.png";
import { MdOutlineDriveFolderUpload } from "react-icons/md";
import { useNavigate } from "react-router-dom";
// import { useViews } from "@mui/x-date-pickers/internals/hooks/useViews";
import EarningDataGrid from "./EarningDataGrid";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import BasicCard from "./EarningBoxes";
import Withdraw from "./Withdraw";
import dayjs from "dayjs";
import { Modal, Form } from "react-bootstrap";
// import {
//   FormControl,
//   FormControlLabel,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { scroller } from "react-scroll";
import MapWithModal from "../fields/MapWithLocation";
// import { Autocomplete } from "react-google-autocomplete";

const EditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  let fullPhoneNumber= userDetail?.data?.country_code+userDetail?.data?.phoneNumber;
  const editProfile = useSelector((state) => state?.auth?.editProfile);
  const withdrawResponse = useSelector((state) => state?.auth?.withdraw);
  // const loginDetail = useSelector((state) => state?.auth?.loginDetail)
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const userEditDetail = useSelector((state) => state?.auth?.editProfile);
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const earning = useSelector((state) => state?.auth?.earning);
  const withdrawRequest = useSelector((state) => state?.auth?.withdrawRequest);

  const [edit, setEdit] = useState(false);
  const [errmsg, setErrMsg] = useState({
    nameErrMsg: "",
    mailErrMsg: "",
    phoneErrMsg: "",
    addressErrMsg: "",
    imageErrMsg: "",
  });
  const [phone, setPhone] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countyCode, setCountyCode] = useState("");
  const [pwdHide, setPwdHide] = useState(false);
  const [confirmPwdHide, setConfirmPwdHide] = useState(false);
  const [editDetail, setEditDetail] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    image: {},
    licenceBack: {},
    licenceFront: {},
    IDFront: {},
    IDBack: {},
    changePassword: "",
    confirmPassword: "",
  });
  const [imgPreview, setImgPreview] = useState({
    image: null,
    IDFront: null,
    IDBack: null,
    licenceFront: null,
  });
  const [tableData, setTableData] = useState(earning?.data?.bookings);
  const [withdraw, setWithDraw] = useState(false);
  const [payPal, setPayPal] = useState(false);
  // const [showWithdrawTable, setShowWithdrawTable] = useState(false);
  const [showWithdrawTable, setShowWithdrawTable] = useState(() => {
    const savedShowWithdrawTable = sessionStorage.getItem("showWithdrawTable");
    return savedShowWithdrawTable ? JSON.parse(savedShowWithdrawTable) : false;
  });
  const [location, setLocation] = useState("");

  useEffect(() => {
    handleBookingInfo({ target: { name: "address", value: location } });
  }, [location]);

  const handleBookingInfo = (event) => {
    const { name, value } = event.target;
    setEditDetail((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // Update session storage whenever the state changes
  useEffect(() => {
    sessionStorage.setItem(
      "showWithdrawTable",
      JSON.stringify(showWithdrawTable)
    );
  }, [showWithdrawTable]);
  useEffect(() => {
    if (loginDetail) dispatch(getUserDetail(loginDetail));
    return () => {
      sessionStorage.removeItem("profileSelected");
      sessionStorage.removeItem("showWithdrawTable");
    };
  }, []);
  const [isModalVisible, setModalVisible] = useState(false);
  // const [withDrawModal, setWithDrawModal] = useState("");
  const [selectedOption, setSelectedOption] = useState("bank");
  const columns = [
    { field: "id", headerName: "S.No.", width: 100 },
    { field: "user", headerName: "User Name", width: 120 },
    { field: "car", headerName: "Car Maker", width: 100 },
    { field: "model", headerName: "Car Model", width: 100 },
    {
      field: "pickUpDateandTime",
      headerName: "Pickup Date & Time",
      width: 150,
    },
    {
      field: "returnDateandTime",
      headerName: "Return Date & Time",
      width: 150,
    },
    // { field: "amount", headerName: "Amount", width: 80 },
    { field: "userEarnings", headerName: "User Earnings", width: 100 },
    { field: "totalAmount", headerName: "Total Amount", width: 100 },
    { field: "status", headerName: "Status", width: 100 },
    // Add more columns as needed
  ];
  const rows =
    earning?.data?.bookings?.map((item, index) => ({
      id: index + 1,
      // _id: item?._id,
      user: item?.user?.name,
      car: `${item?.car?.maker?.carMake}`,
      model: `${item?.car?.model?.carModel}`,
      pickUpDateandTime: dayjs(item?.pickUpDateandTime)?.format(
        "YYYY-MM-DD hh:mm A"
      ),
      returnDateandTime: dayjs(item?.returnDateandTime)?.format(
        "YYYY-MM-DD hh:mm A"
      ),
      // amount: item?.amount,
      userEarnings: item?.userEarning,
      totalAmount: item?.totalAmount,
      status: item?.status,
    })) || [];

  const columns1 = [
    { field: "id", headerName: "S.No.", width: 270 },
    { field: "type", headerName: "Payment Mode", width: 270 },
    { field: "withdrawAmount", headerName: "Amount", width: 270 },
    { field: "status", headerName: "Status", width: 270 },
  ];
  const rows1 =
    withdrawRequest?.data?.map((item, index) => ({
      id: index + 1,
      type: item?.type,
      withdrawAmount: item?.withdrawAmount,
      status: item?.status,
    })) || [];

  // const rows = [tableData]
  // //  [
  // //     { id: 1, name: "John", age: 30, country: "USA" },
  // //     { id: 2, name: "Jane", age: 25, country: "Canada" },
  // //     { id: 3, name: "Bob", age: 40, country: "UK" },
  // //     // Add more rows as needed
  // // ];

  // // Columns configuration
  // const columns =
  //     [
  //         { field: "_id", headerName: "ID", width: 100 },
  //         { field: "amount", headerName: "amount", width: 100 },
  //         // { field: "name", headerName: "Name", width: 150 },
  //         // { field: "age", headerName: "Age", width: 100 },
  //         // { field: "country", headerName: "Country", width: 150 },
  //         // Add more columns as needed
  //     ];

  // const [profileSelected, setProfileSelected] = useState("user");
  const [profileSelected, setProfileSelected] = useState(() => {
    const savedProfile = sessionStorage.getItem("profileSelected");
    return savedProfile ? JSON.parse(savedProfile) : "user";
  });

  // Update session storage whenever the state changes
  useEffect(() => {
    sessionStorage.setItem("profileSelected", JSON.stringify(profileSelected));
  }, [profileSelected]);
  let document;

  const notify = (msg) => toast(`${msg}`);

  useDispatch(() => {
    const filteredArray = earning?.data?.bookings?.map((item) => ({
      id: item._id,
      totalAmount: item.totalAmount,
      commissionPrice: item.commissionPrice,
      commission: item.commission,
      amount: item.amount,
      pickUpDateandTime: item.pickUpDateandTime,
      returnDateandTime: item.returnDateandTime,
    }));

    setTableData(filteredArray); // Update the state variable
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  useEffect(() => {
    if (!loginDetail) {
      navigate("/login");
    }
    dispatch(getEarning(userDetail?.data?._id));
    dispatch(fetchWithdrawls(userDetail?.data?._id));
  }, [withdrawResponse]);

  useEffect(() => {
    if (userDetail?.success === true) {
      setEditDetail({
        fullName: userDetail?.data?.name || "",
        email: userDetail?.data?.emailId || "",
        address: userDetail?.data?.address || "",
        image: userDetail?.data?.image ? `${baseURL}${userDetail?.data?.image}` : null,
        licenceFront: userDetail?.data?.drivingLicenseFront ? `${baseURL}${userDetail?.data?.drivingLicenseFront}` : null,
        IDFront: userDetail?.data?.identityFront ? `${baseURL}${userDetail?.data?.identityFront}` : null,
        IDBack: userDetail?.data?.identityBack ? `${baseURL}${userDetail?.data?.identityBack}` : null,
        changePassword: "",
        confirmPassword: "",
      });
      setImgPreview({
        image: userDetail?.data?.image ? `${baseURL}${userDetail?.data?.image}` : null,
        IDFront: userDetail?.data?.identityFront ? `${baseURL}${userDetail?.data?.identityFront}` : null,
        IDBack: userDetail?.data?.identityBack ? `${baseURL}${userDetail?.data?.identityBack}` : null,
        licenceFront: userDetail?.data?.drivingLicenseFront ? `${baseURL}${userDetail?.data?.drivingLicenseFront}` : null,
      })
      setPhoneNumber(userDetail?.data.phoneNumber);
      setCountyCode(userDetail?.data?.country_code)
      setLocation(userDetail?.data.address);
      let fullNumber=userDetail?.data?.country_code+userDetail?.data.phoneNumber;
      setPhone(`${fullNumber}`);
      // setPhone(`${userDetail?.data.phoneNumber}`);
    }

    if (userEditDetail?.success === true) {
      dispatch(getUserDetail(loginDetail));

      setEditDetail({
        fullName: userDetail?.data.name,
        email: userDetail?.data.emailId,
        address: userDetail?.data.address,
        image: "",
      });
      let fullNumber=userDetail?.data?.country_code+userDetail?.data.phoneNumber;
      // setPhone(`${userDetail?.data.phoneNumber}`);
      setPhone(`${fullNumber}`);
    }
  }, [userEditDetail, edit]);

  if (
    userDetail?.data?.drivingLicenseFront ||
    userDetail?.data?.drivingLicenseBack ||
    userDetail?.data?.identityBack ||
    userDetail?.data?.dentityFront
  ) {
    document = true;
  }

  const handleToggleEdit = () => {
    if (!edit) {
      scroller.scrollTo("editProfileScroll", {
        duration: 200,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -150, // Adjust offset here
      });
    }
    setEdit(!edit);
  };

  const handleChange = (newPhone,info) => {
    setCountyCode(info?.countryCallingCode);
    setPhoneNumber(info?.nationalNumber);
    setPhone(newPhone);
  };

  const handleInput = (event) => {
    const { name, value, type, files } = event.target;

    if (type === "file") {
      const file = files[0];

      if (file) {
        setEditDetail((prevFormData) => ({ ...prevFormData, [name]: file }));
        // Create a FileReader to read the file and set the preview URL
        const reader = new FileReader();
        reader.onloadend = () => {
          setImgPreview((prev) => ({
            ...prev,
            [name]: reader.result,
          }));
        };
        reader.readAsDataURL(file);
      }
    } else {
      setEditDetail((prevFormData) => ({ ...prevFormData, [name]: value }));
    }
  };

  const handleSubmit = () => {
    const isPhoneValid = matchIsValidTel(phone);
    const mailValid = isValidEmail(editDetail.email);
    let newErrMsg = {};
    if (editDetail.fullName.trim() === "")
      newErrMsg = { ...newErrMsg, nameErrMsg: "Please Enter Full Name" };
    if (mailValid === false)
      newErrMsg = { ...newErrMsg, mailErrMsg: "Please Enter valid Mail" };
    // if (editDetail.address === '') newErrMsg = { ...newErrMsg, addressErrMsg: "Please Enter Address" };
    if (!isPhoneValid)
      newErrMsg = { ...newErrMsg, phoneErrMsg: "Please Enter valid Phone" };
    // if (editDetail.image === '') newErrMsg = { ...newErrMsg, imageErrMsg: "Please Upload Image" };
    if (
      editDetail?.changePassword?.length ||
      editDetail?.confirmPassword?.length
    ) {
      if (editDetail?.changePassword !== editDetail?.confirmPassword) {
        newErrMsg = { ...newErrMsg, passwordErrMsg: "Password not Match" };
      } else if (editDetail?.changePassword?.length < 6) {
        newErrMsg = {
          ...newErrMsg,
          passwordErrMsg: "Password must be at least 6 characters long",
        };
      }
    }
    setErrMsg(newErrMsg);

    if (
      editDetail.fullName.trim() === "" ||
      mailValid === false ||
      !isPhoneValid ||
      Object.keys(newErrMsg)?.length
    ) {
      return;
    } else {
      const formData = new FormData();
      formData.append("name", editDetail?.fullName);
      formData.append("emailId", editDetail?.email);
      // formData.append("phoneNumber", phone);
      formData.append("phoneNumber", phoneNumber);
      formData.append("country_code", countyCode.startsWith("+") ? countyCode : "+" + countyCode);
      formData.append("image", editDetail?.image);
      formData.append("address", editDetail?.address);
      formData.append("changePassword", editDetail?.changePassword);
      formData.append("confirmPassword", editDetail?.confirmPassword);
      formData.append("identityBack", editDetail?.IDBack);
      formData.append("identityFront", editDetail?.IDFront);
      formData.append("drivingLicenseBack", editDetail?.licenceBack);
      formData.append("drivingLicenseFront", editDetail?.licenceFront);
      dispatch(EditUserProfile({ id: userDetail?.data?._id, data: formData }));
      // notify(`Updated Successfully`);

      scrollToTop();
      setEdit(false);
    }
  };

  const withdrawHandler = () => {
    setWithDraw(true);
    setPayPal(false);
  };
  const paypalHandler = () => {
    setPayPal(true);
    setWithDraw(true);
  };

  const WithDrawModalHandler = useCallback(() => {
    setModalVisible(!isModalVisible);
    // setWithDrawModal();
    setWithDraw(true);
  }, []);
  useEffect(() => {
    toast(editProfile?.message);
    if (Object.keys(editProfile).length) dispatch(clearEditProfile());
  }, [editProfile]);

  return (
    <>
      <div className="container-xxl">
        <div className="row">
          <div className="col-lg-2 col-md-3  h-50 mt-5 p-0 d-flex flex-lg-column flex-wrap  flex-row row-gap-3 column-gap-1 column-gap-sm-4 justify-content-center align-items-center ">
            <button
              className={`d-block btn my-account-btns px-1 user_profile_btn primaryColor ${
                profileSelected === "user" ? "user_active_btn" : ""
              }`}
              onClick={() => setProfileSelected("user")}
            >
              Profile
            </button>
            <button
              className={`d-block btn my-account-btns px-1 user_profile_btn primaryColor ${
                profileSelected === "earning" ? "user_active_btn" : ""
              }`}
              onClick={() => {
                setProfileSelected("earning");
                setWithDraw(false);
              }}
            >
              Earning
            </button>
            <button
              className={`d-block btn my-account-btns px-1 user_profile_btn primaryColor ${
                profileSelected === "withdraw history" ? "user_active_btn" : ""
              }`}
              onClick={() => {
                setProfileSelected("withdraw history");
                setShowWithdrawTable(true);
              }}
            >
              Withdraw History
            </button>
            {profileSelected === "withdraw history" && (
              <button
                className={`btn user_profile_btn d-lg-none d-md-block my-account-btns
                  ${isModalVisible ? "user_active_btn" : ""}
                  `}
                onClick={WithDrawModalHandler}
              >
                {console.log(
                  "profileSelected",
                  profileSelected,
                  showWithdrawTable
                )}
                Withdraw
              </button>
            )}
            {/* {
                        profileSelected === "earning" ?
                            <>

                                <button className='d-block btn my-account-btns px-3 img-btn primaryColor ' onClick={withdrawHandler} >To Bank Account</button>
                                <button className='d-block btn my-account-btns px-3 img-btn primaryColor ' onClick={paypalHandler} >To Paypal</button>


                            </>
                            :
                            null
                    } */}
          </div>
          <div className="col-lg-10 p-0 col-md-9">
            {profileSelected === "user" ? (
              <div className="container pb-6">
                <div className="row justify-content-center pt-5 mb-md-4">
                  <div className="col-md-7 col-lg-8 mb-4 mb-4 mb-md-0">
                    <div className="card radio-shadow h-100 border-0">
                      <h3 className="booking-label border-0 font card-header">
                        User Information
                      </h3>
                      <div className="card-body">
                        <div className="row">
                          <div className="align-items-center d-flex gap-3 flex-wrap mb-4">
                            <img
                              src={`${
                                userDetail?.data?.image
                                  ? userDetail?.data?.image.includes("http")
                                    ? userDetail?.data?.image
                                    : `${baseURL}${userDetail?.data?.image}`
                                  : user
                              }`}
                              className="editprofpic rounded-circle"
                            />
                            <div className="align-items-center d-flex gap-3 flex-wrap mb-4">
                              <h1 className="font accentColor text-center   mb-0">
                                {userDetail?.data?.name}
                                <img
                                  src={editPen}
                                  className="ms-2 profile-edit-pen pointor"
                                  data-tooltip-id="edit-pen"
                                  onClick={handleToggleEdit}
                                />
                              </h1>
                              <ReactTooltip
                                id="edit-pen"
                                place="bottom"
                                content="Edit"
                              />
                            </div>
                          </div>

                          <div>
                            <p className="para_tag">
                              <span className="user_profile">Full Name</span>
                              <span className="accentColor vertical_top text-capitalize">
                                {userDetail?.data?.name}
                              </span>
                            </p>
                            <p className="para_tag">
                              <span className="user_profile">Email</span>
                              <span className="accentColor vertical_top">
                                {userDetail?.data?.emailId}
                              </span>
                            </p>
                            <p className="para_tag">
                              <span className="user_profile">Phone</span>
                              <span className="accentColor vertical_top">
                                {/* {userDetail?.data?.phoneNumber} */}
                                {fullPhoneNumber}
                              </span>
                            </p>
                            {userDetail?.data?.address ? (
                              <p className="para_tag">
                                <span className="user_profile">Address</span>
                                <span className="accentColor vertical_top">
                                  {userDetail?.data?.address}
                                </span>
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 col-lg-4 mb-4 mb-md-0">
                    <div className="card radio-shadow h-100 border-0">
                      <h3 className="booking-label border-0 font card-header text-start">
                        Documents
                      </h3>
                      <div className="card-body">
                        {document === true ? (
                          <>
                            {/* <h4 className="text-center text-lg-start mt-3 mt-lg-0 ">
                              Documents
                            </h4> */}
                            <div className="text-center text-md-start">
                              <div className="row g-2">
                                {/* {(userDetail?.data?.drivingLicenseBack || userDetail?.data?.drivingLicenseFront) ?
                                                        <div className='col-md-6 col-lg-12 py-2' >
                                                            <p className='doc-heading text-center' >Licence</p>
                                                            <div className='row text-center' >
                                                                <div className='col-6' >
                                                                    {(userDetail?.data?.drivingLicenseFront) ?
                                                                        <img src={`${baseURL}${userDetail?.data?.drivingLicenseFront}`} className='doc-img' />
                                                                        : null
                                                                    }
    
                                                                </div>
                                                                <div className='col-6' >
                                                                    {(userDetail?.data?.drivingLicenseBack) ?
                                                                        <img src={`${baseURL}${userDetail?.data?.drivingLicenseBack}`} className='doc-img' />
                                                                        : null
                                                                    }
    
                                                                </div>
                                                            </div>
                                                        </div>
    
                                                        : null
                                                    } */}

                                {userDetail?.data?.identityFront ||
                                userDetail?.data?.identityBack ? (
                                  <div className=" col-lg-12 py-2">
                                    <p className="doc-heading text-center mb-3">
                                      ID Cards
                                    </p>
                                    <div className="row text-center">
                                      {/* <div className="col-6 col-lg-12 col-xl-6"> */}
                                      {userDetail?.data?.identityFront ? (
                                        <div className="col-6 col-sm-4 col-md-12 col-xl-6 py-2">
                                          <img
                                            src={`${baseURL}${userDetail?.data?.identityFront}`}
                                            className="doc-img"
                                          />
                                        </div>
                                      ) : null}

                                      {/* <div className="col-6 col-lg-12 col-xl-6"> */}
                                      {userDetail?.data?.identityBack ? (
                                        <div className="col-6 col-sm-4 col-md-12 col-xl-6 py-2">
                                          <img
                                            src={`${baseURL}${userDetail?.data?.identityBack}`}
                                            className="doc-img"
                                          />
                                        </div>
                                      ) : null}
                                      {/* <div className="col-6 col-lg-12 col-xl-6"> */}
                                      {userDetail?.data?.drivingLicenseFront ? (
                                        <div className="col-6 col-sm-4 col-md-12 col-xl-6 py-2">
                                          <img
                                            src={`${baseURL}${userDetail?.data?.drivingLicenseFront}`}
                                            className="doc-img"
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <h5
                              onClick={handleToggleEdit}
                              data-tooltip-id="upload-doc"
                              className="text-center pointor  my-2"
                            >
                              Upload Documents
                              <MdOutlineDriveFolderUpload className="accentColor ms-2" />
                            </h5>

                            <img src={licence} className="img-licence my-3" />
                            <p className="text-secondary">
                              Upload licence/Id to verify your Profile
                            </p>
                            <ReactTooltip
                              id="upload-doc"
                              place="bottom"
                              content="Upload"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div name="editProfileScroll">
                  {edit ? (
                    <div className="card radio-shadow border-0">
                      <h3 className="booking-label border-0 font card-header">
                        Edit Profile
                      </h3>
                      <div className="card-body">
                        <div className="row  px-md-0">
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <TextInput
                                type="text"
                                labelName="Full Name"
                                id="fullname"
                                size="small"
                                name="fullName"
                                value={editDetail?.fullName}
                                onChange={handleInput}
                                error={!!errmsg?.nameErrMsg}
                                helperText={errmsg?.nameErrMsg}
                                formPlaceholder="Enter Your Name"
                                shrink="false"
                                animation="true"
                              />
                            </div>
                          </div>
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="input-label my-2">
                                Phone Number{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <MuiTelInput
                                error={!!errmsg?.phoneErrMsg}
                                // disableFormatting
                                defaultCountry="ZM"
                                value={phone}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                sx={{ width: "100%" }}
                                helperText={errmsg?.phoneErrMsg}
                              />
                            </div>
                          </div>
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <TextInput
                                type="email"
                                labelName="Email"
                                id="email"
                                size="small"
                                name="email"
                                value={editDetail?.email}
                                onChange={handleInput}
                                error={!!errmsg?.mailErrMsg}
                                helperText={errmsg?.mailErrMsg}
                                formPlaceholder="Enter Your Email"
                                shrink="false"
                                animation="true"
                              />
                            </div>
                          </div>
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <label className="input-label my-2">
                                Address<span style={{ color: "red" }}>*</span>
                              </label>
                              <MapWithModal
                                type="edit address"
                                placeholder="Address"
                                error={!!errmsg?.locationErrMsg}
                                helperText={errmsg?.locationErrMsg}
                                setLocation={setLocation}
                                location={location}
                              />
                              {/* <TextInput
                                type="text"
                                labelName="Address"
                                id="address"
                                size="small"
                                name="address"
                                value={editDetail?.address}
                                onChange={handleInput}
                                error={!!errmsg?.addressErrMsg}
                                helperText={errmsg?.addressErrMsg}
                                formPlaceholder="Enter Your Address"
                                shrink="false"
                                animation="true"
                                requiredStar={true}
                              /> */}
                            </div>
                          </div>
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <p className="input-label my-2">
                                Upload Profile Picture
                              </p>
                              <div className="file-input">
                                <label
                                  className={`file-input__label ${
                                    errmsg.imageErrMsg ? "error" : null
                                  }`}
                                  htmlFor="image"
                                >
                                  <input
                                    type="file"
                                    name="image"
                                    id="image"
                                    className="file-input__input"
                                    onChange={handleInput}
                                  />
                                  {/* new code with preview */}
                                  {editDetail.image ? (
                                    <>
                                      <img
                                        className="upload-doc mx-auto pointor"
                                        src={imgPreview?.image}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <MdOutlineFileUpload className="upload-icon me-1" />
                                      <span className="text-truncate">
                                        {editDetail.image
                                          ? editDetail.image.name
                                          : "Upload"}
                                      </span>
                                    </>
                                  )}
                                  {/* old code without preview */}
                                  {/* <MdOutlineFileUpload className="upload-icon me-1" />
                                    <span className="text-truncate">
                                      {editDetail.image
                                        ? editDetail.image.name
                                        : "Upload"}
                                    </span> */}
                                </label>
                                <p className="location-err">
                                  {errmsg.imageErrMsg}
                                </p>
                              </div>
                              {/* 
                                
                                <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carFrontImg ? "error" : null
                }`}
                htmlFor="carFrontImg"
              >
                <input
                  disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carFrontImg"
                  id="carFrontImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carFrontImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    src={
                      CarDetail?.carFrontImg?.base64
                        ? CarDetail?.carFrontImg.base64
                        : `${baseURL}${CarDetail?.carFrontImg}`
                    }
                  />
                ) : (
                  // src={`${CarDetail?.carFrontImg?.base64}`} />
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}


              </label>
              <p className="location-err">{errmsg.carFrontImg}</p>
            </div>
                                */}
                            </div>
                          </div>
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <p className="input-label my-2">
                                Upload Identity Card (Front-Side)
                              </p>
                              <div className="file-input">
                                <label
                                  className={`file-input__label ${
                                    errmsg.imageErrMsg ? "error" : null
                                  }`}
                                  htmlFor="IDFront"
                                >
                                  <input
                                    type="file"
                                    name="IDFront"
                                    id="IDFront"
                                    className="file-input__input"
                                    onChange={handleInput}
                                  />
                                  {/* new code with preview */}
                                  {editDetail.IDFront ? (
                                    <>
                                      <img
                                        className="upload-doc mx-auto pointor"
                                        src={imgPreview?.IDFront}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <MdOutlineFileUpload className="upload-icon me-1" />
                                      <span className="text-truncate">
                                        {editDetail.IDFront
                                          ? editDetail.IDFront.name
                                          : "Upload"}
                                      </span>
                                    </>
                                  )}
                                  {/* old code without preview */}
                                  {/* <MdOutlineFileUpload className="upload-icon me-1" />
                                    <span className="text-truncate">
                                      {editDetail.IDFront
                                        ? editDetail.IDFront.name
                                        : "Upload"}
                                    </span> */}
                                </label>
                                <p className="location-err">
                                  {errmsg.imageErrMsg}
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <p className="input-label my-2">
                                Upload Identity Card (Back-Side)
                              </p>
                              <div className="file-input">
                                <label
                                  className={`file-input__label ${
                                    errmsg.imageErrMsg ? "error" : null
                                  }`}
                                  htmlFor="IDBack"
                                >
                                  <input
                                    type="file"
                                    name="IDBack"
                                    id="IDBack"
                                    className="file-input__input"
                                    onChange={handleInput}
                                  />
                                  {/* new code with preview */}
                                  {editDetail.IDBack ? (
                                    <>
                                      <img
                                        className="upload-doc mx-auto pointor"
                                        src={imgPreview?.IDBack}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <MdOutlineFileUpload className="upload-icon me-1" />
                                      <span className="text-truncate">
                                        {editDetail.IDBack
                                          ? editDetail.IDBack.name
                                          : "Upload"}
                                      </span>
                                    </>
                                  )}
                                  {/* old code without preview */}
                                  {/* <MdOutlineFileUpload className="upload-icon me-1" />
                                    <span className="text-truncate">
                                      {editDetail.IDBack
                                        ? editDetail.IDBack.name
                                        : "Upload"}
                                    </span> */}
                                </label>
                                <p className="location-err">
                                  {errmsg.imageErrMsg}
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* Licence field added */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3">
                              <p className="input-label my-2">
                                Upload Licence (Front-Side)
                              </p>
                              <div className="file-input">
                                <label
                                  className={`file-input__label `}
                                  htmlFor="licenceFront"
                                >
                                  <input
                                    type="file"
                                    name="licenceFront"
                                    id="licenceFront"
                                    className="file-input__input"
                                    onChange={handleInput}
                                  />
                                  {/* new code with preview */}
                                  {editDetail.licenceFront ? (
                                    <>
                                      <img
                                        className="upload-doc mx-auto pointor"
                                        src={imgPreview?.licenceFront}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <MdOutlineFileUpload className="upload-icon me-1" />
                                      <span className="text-truncate">
                                        {editDetail.licenceFront
                                          ? editDetail.licenceFront.name
                                          : "Upload"}
                                      </span>
                                    </>
                                  )}
                                  {/* old code without preview */}
                                  {/* <MdOutlineFileUpload className="upload-icon me-1" />
                                    <span className="text-truncate">
                                      {editDetail.IDBack
                                        ? editDetail.IDBack.name
                                        : "Upload"}
                                    </span> */}
                                </label>
                                <p className="location-err">
                                  {errmsg.imageErrMsg}
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3 position-relative ">
                              {/* <div className="position-relative"> */}
                              {/* <TextInput
                              type={pwdHide ? "text" : "password"}
                              // id="password"
                              size="small"
                              name="password"
                              value={loginDetail.password}
                              onChange={handleInput}
                              error={!!errmsg.passwordErrMsg}
                              helperText={errmsg.passwordErrMsg}
                              formPlaceholder="Enter Password"
                              shrink="false"
                              animation="true"
                              requiredStar={false}
                              labelName={"Password"}
                            /> */}
                              <TextInput
                                type={pwdHide ? "text" : "password"}
                                labelName="Password"
                                id="password"
                                size="small"
                                name="changePassword"
                                value={editDetail?.changePassword}
                                onChange={handleInput}
                                error={!!errmsg?.passwordErrMsg}
                                helperText={errmsg?.passwordErrMsg}
                                formPlaceholder="Enter Your Password"
                                shrink="false"
                                animation="true"
                                requiredStar={true}
                                autocomplete={false}
                              />
                              <span className="position-absolute edit_eye">
                                {pwdHide ? (
                                  <FaRegEye
                                    onClick={() => setPwdHide(!pwdHide)}
                                  />
                                ) : (
                                  <FaRegEyeSlash
                                    onClick={() => setPwdHide(!pwdHide)}
                                  />
                                )}
                              </span>
                              {/* </div> */}
                            </div>
                          </div>
                          {/* <div className="col-md-4"> */}
                          <div className="col-lg-4 col-md-6">
                            <div className="mb-3 position-relative ">
                              {/* <div className="position-relative"> */}
                              {/* <TextInput
                              type={pwdHide ? "text" : "password"}
                              // id="password"
                              size="small"
                              name="password"
                              value={loginDetail.password}
                              onChange={handleInput}
                              error={!!errmsg.passwordErrMsg}
                              helperText={errmsg.passwordErrMsg}
                              formPlaceholder="Enter Password"
                              shrink="false"
                              animation="true"
                              requiredStar={false}
                              labelName={"Password"}
                            /> */}
                              <TextInput
                                type={confirmPwdHide ? "text" : "password"}
                                labelName="Confirm Password"
                                id="confirm-password"
                                size="small"
                                name="confirmPassword"
                                value={editDetail?.confirmPassword}
                                onChange={handleInput}
                                // error={!!errmsg?.passwordErrMsg}
                                // helperText={errmsg?.passwordErrMsg}
                                formPlaceholder="Confirm Password"
                                shrink="false"
                                animation="true"
                                requiredStar={true}
                              />
                              <span className="position-absolute edit_eye">
                                {confirmPwdHide ? (
                                  <FaRegEye
                                    onClick={() =>
                                      setConfirmPwdHide(!confirmPwdHide)
                                    }
                                  />
                                ) : (
                                  <FaRegEyeSlash
                                    onClick={() =>
                                      setConfirmPwdHide(!confirmPwdHide)
                                    }
                                  />
                                )}
                              </span>
                              {/* </div> */}
                            </div>
                          </div>
                          {/* <div className='col-md-4' >
                                        <div className='mb-3' >
                                            <p className='input-label mb-2' >Upload Licence (Front)</p>
                                            <div className="file-input">
                                                <label
                                                    className={`file-input__label ${errmsg.imageErrMsg ? "error" : null}`}
                                                    htmlFor="licenceFront">
                                                    <input
                                                        type="file"
                                                        name="licenceFront"
                                                        id="licenceFront"
                                                        className="file-input__input"
                                                        onChange={handleInput}
                                                    />
                                                    <MdOutlineFileUpload className='upload-icon me-1' />
                                                    <span className="text-truncate" >{editDetail.licenceFront ? editDetail.licenceFront.name : "Upload"}</span>
                                                </label>
                                                <p className='location-err' >{errmsg.imageErrMsg}</p>
                                            </div>
                                        </div>
                                    </div> */}
                          {/* <div className='col-md-4' >
                                        <div className='mb-3' >
                                            <p className='input-label mb-2' >Upload Licence (Back)</p>
                                            <div className="file-input">
                                                <label
                                                    className={`file-input__label ${errmsg.imageErrMsg ? "error" : null}`}
                                                    htmlFor="licenceBack">
                                                    <input
                                                        type="file"
                                                        name="licenceBack"
                                                        id="licenceBack"
                                                        className="file-input__input"
                                                        onChange={handleInput}
                                                    />
                                                    <MdOutlineFileUpload className='upload-icon me-1' />
                                                    <span className="text-truncate" >{editDetail.licenceBack ? editDetail.licenceBack.name : "Upload"}</span>
                                                </label>
                                                <p className='location-err' >{errmsg.imageErrMsg}</p>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div className='col-md-4' >
                                        <div className='mb-3' >
                                            <p className='input-label mb-2' >Upload National Id (Front)</p>
                                            <div className="file-input">
                                                <label
                                                    className={`file-input__label ${errmsg.imageErrMsg ? "error" : null}`}
                                                    htmlFor="IDFront">
                                                    <input
                                                        type="file"
                                                        name="IDFront"
                                                        id="IDFront"
                                                        className="file-input__input"
                                                        onChange={handleInput}
                                                    />
                                                    <MdOutlineFileUpload className='upload-icon me-1' />
                                                    <span className="text-truncate" >{editDetail.IDFront ? editDetail.IDFront.name : "Upload"}</span>
                                                </label>
                                                <p className='location-err' >{errmsg.imageErrMsg}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4' >
                                        <div className='mb-3' >
                                            <p className='input-label mb-2' >Upload National Id (Back)</p>
                                            <div className="file-input">
                                                <label
                                                    className={`file-input__label ${errmsg.imageErrMsg ? "error" : null}`}
                                                    htmlFor="IDBack">
                                                    <input
                                                        type="file"
                                                      name="IDBack"
                                                        id="IDBack"
                                                        className="file-input__input"
                                                        onChange={handleInput}
                                                    />
                                                    <MdOutlineFileUpload className='upload-icon me-1' />
                                                    <span className="text-truncate" >{editDetail.IDBack ? editDetail.IDBack.name : "Upload"}</span>
                                                </label>
                                                <p className='location-err' >{errmsg.imageErrMsg}</p>
                                            </div>
                                        </div>
                                    </div> */}

                          <div className="d-flex justify-content-center  mt-md-2">
                            <button
                              type="submit"
                              onClick={handleSubmit}
                              className="btn col-md-6 col-12 col-lg-4 px-3 img-btn primaryColor mt-4"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : profileSelected === "earning" ? (
              // <div className="container  pb-6">
              <div className="container-xl  pb-6">
                <>
                  {withdraw === true ? (
                    <>
                      <Withdraw paypal={payPal} />
                    </>
                  ) : (
                    <>
                      <div className="d-flex flex-wrap justify-content-center mb-4 mt-5 gap-1 gap-md-2 justify-content-sm-between">
                        <BasicCard
                          amount={earning?.data?.totalAmountSum}
                          heading={"Total Earning"}
                        />
                        {/* <BasicCard amount={earning?.data?.totalCommission} heading={"Commission"} /> */}
                        <BasicCard
                          amount={earning?.data?.userEarnings}
                          heading={"Available Amount"}
                        />
                      </div>
                      <EarningDataGrid rows={rows} columns={columns} />
                    </>
                  )}
                </>
              </div>
            ) : profileSelected === "withdraw history" && showWithdrawTable ? (
              <div className="container mt-5 pb-6">
                <div className="d-flex justify-content-end mb-2">
                  <button
                    className={`btn user_profile_btn d-none d-lg-block  ${
                      isModalVisible ? "user_active_btn" : ""
                    } `}
                    onClick={WithDrawModalHandler}
                  >
                    Withdraw
                  </button>
                </div>
                <Modal
                  show={isModalVisible}
                  onHide={() => setModalVisible(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="font accentColor-imp text-align-center">
                      Withdraw
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <h5 className="text-end mb-2 accentColor-imp ">
                      Available Amount: {earning?.data?.userEarnings || 0}
                    </h5>
                    <Form>
                      <div className="mb-3 d-flex justify-content-evenly">
                        <Form.Check
                          type="radio"
                          id="bank"
                          label="To Bank Account"
                          name="withdrawOption"
                          value="bank"
                          checked={selectedOption === "bank"}
                          onChange={(e) => {
                            setSelectedOption(e.target.value);
                            setPayPal(false);
                          }}
                        />
                        <Form.Check
                          type="radio"
                          id="paypal"
                          label="To Paypal"
                          name="withdrawOption"
                          value="paypal"
                          checked={selectedOption === "paypal"}
                          className="pointer"
                          onChange={(e) => {
                            setSelectedOption(e.target.value);
                            setPayPal(true);
                          }}
                        />
                      </div>
                    </Form>
                    {withdraw === true ? (
                      <>
                        <Withdraw paypal={payPal} />
                      </>
                    ) : null}
                  </Modal.Body>
                </Modal>
                <EarningDataGrid rows={rows1} columns={columns1} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(EditProfile);
